import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const CloseIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Close`} {...props}>
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="m3 3 10 10M3 13 13 3"
      fill="none"
    />
  </Icon>
);
